<div fxLayout="row wrap" fxLayoutAlign="center" style="margin-top: 10px;"fxLayout="row wrap" fxLayoutAlign="center" style="margin-top: 10px;">
    <div fxFlex="96" fxFlex.xs="100">
        <mat-card *hasPermission="['EDIT_SPEC']" class="mb-15">
            <mat-card-header>
                <mat-card-title>Swatching</mat-card-title>
            </mat-card-header>

            <app-swatching-header [headerForm]="swatchService.headerForm" [categoryId]="categoryId"></app-swatching-header>

        </mat-card>
        
        <mat-toolbar style="width: 100%;" color="primary" class="mb-10">
            <ng-container *hasPermission="['EDIT_SPEC']; else viewOnly">
                <span>Create Swatching</span>
            </ng-container>
            <ng-template #viewOnly>
                <span>View Swatching</span>
            </ng-template>
            <span class="example-spacer"></span>
        </mat-toolbar>

        <mat-card>
            <app-swatching (submitForm)="submitForm()"></app-swatching>
        </mat-card>

    </div>
</div>